import { FC } from 'react';

import { SelectInput } from '@monoimin/molecules/inputs/SelectInput';

import { MultiSelectInput } from '@monoimin/molecules/inputs/MultiSelectInput';

import { PhoneInput } from '@monoimin/molecules/inputs/PhoneInput';

import { TextInput } from '@monoimin/molecules/inputs/TextInput';

import { showByConditionalLogic } from '@monoimin/utils/helpers';
import { CheckboxGravityForm } from '@monoimin/atoms/components/checkbox/CheckboxGravityForm';
import { RadioButton } from '@monoimin/atoms/components/radio-button/RadioButton';

import { DateInput } from '@monoimin/molecules/inputs/DateInput';
import { HiddenInput } from '@monoimin/molecules/inputs/HiddenInput';

import { TextAreaInput } from '@monoimin/molecules/inputs/TextAreaInput';
import { FileInput } from '@monoimin/molecules/inputs/FileInput';

import { FieldConfig, InputProps } from '../types';

export const Inputs: { [type: FieldConfig['type']]: any } = {
  radio: RadioButton,
  text: TextInput,
  date: DateInput,
  email: TextInput,
  phone: PhoneInput,
  hidden: HiddenInput,
  select: SelectInput,
  multiselect: MultiSelectInput,
  checkbox: CheckboxGravityForm,
  consent: CheckboxGravityForm,
  textarea: TextAreaInput,
  fileupload: FileInput,
};

export const RenderInput = (props: InputProps) => {
  const { formValues, type, adminLabel, visibility } = props;
  if (visibility === 'hidden') return null;

  const show = props.conditionalLogic
    ? showByConditionalLogic({
        conditionalLogic: props.conditionalLogic,
        formValuesById: props.formValuesById,
      })
    : true;
  if (!show) return null;

  const InputComponent =
    type in Inputs ? (Inputs[type] as FC<InputProps>) : null;

  if (!InputComponent) return null;

  return (
    <InputComponent
      key={props.customId}
      {...props}
      formValues={formValues}
      value={formValues[adminLabel]}
    />
  );
};

export const RenderInputWithoutChecking = (props: InputProps) => {
  const { formValues, type, adminLabel, visibility } = props;
  if (visibility === 'hidden') return null;

  const InputComponent =
    type in Inputs ? (Inputs[type] as FC<InputProps>) : null;

  if (!InputComponent) return null;

  return (
    <InputComponent
      key={props.customId}
      {...props}
      formValues={formValues}
      value={formValues[adminLabel]}
    />
  );
};
